import { components } from "@/api-schema";
import {
  RelocationOrderStatusContainer,
  RelocationOrderStatusContainerVariant,
} from "./relocation-order-status-container";
import { FitUserType, getStatusConfig } from "./_helpers/get-status-config";

type RelocationOrderStatus = components["schemas"]["RelocationOrder"]["status"];

export function renderRelocationOrderStatus({
  status,
  variant,
  userType = FitUserType.INTERNAL,
  transportMethod,
}: {
  status: RelocationOrderStatus;
  variant?: RelocationOrderStatusContainerVariant;
  userType?: FitUserType;
  transportMethod?: components["schemas"]["RelocationOrder"]["transportMethod"];
}) {
  const config = getStatusConfig(status, userType, transportMethod);

  return <RelocationOrderStatusContainer config={config} variant={variant} />;
}
